import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { message } from 'antd';

import { useAppSelector } from '../Modules/Presentation/hooks';
import { selectAuthToken } from '../Modules/User/Presentation/selectors';
import useOnce from '../Utils/hook/useOnce';

const AuthGate: React.FC = () => {
  const reduxToken = useAppSelector(selectAuthToken);
  const localToken = localStorage.getItem('access');
  const token      = reduxToken ?? localToken;

  const { pathname } = useLocation();

  useOnce(() => {
    if (!token && pathname !== '/login') {
      message.warning('로그인이 필요합니다.');
    }
  });

  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthGate;
